const BASE_URL = 'BASE_URL'
const ACCESS_TOKEN = 'ACCESS_TOKEN'
const ACCESS_TOKEN_NAME = 'ACCESS_TOKEN_NAME'

export { BASE_URL, ACCESS_TOKEN_NAME, ACCESS_TOKEN }